/**
 * Product page: variant option buttons -> matching variant -> live price/media/
 * add-to-cart update; gallery swiper; quantity stepper; related products fetch.
 */
(function () {
  'use strict';

  var form = document.getElementById('ProductForm');
  if (!form) return;

  var jsonEl = document.querySelector('[data-product-json]');
  var product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
  var moneyFormat = (window.themeVars && window.themeVars.moneyFormat) || '${{amount}}';

  function formatMoney(cents) {
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2));
  }

  var selected = {};
  form.querySelectorAll('.quick-variant-picker').forEach(function (picker) {
    var index = picker.getAttribute('data-option-index');
    var activeBtn = picker.querySelector('.size_btn.active');
    if (activeBtn) selected[index] = activeBtn.getAttribute('data-option-value');
  });

  function findVariant() {
    if (!product) return null;
    return product.variants.find(function (variant) {
      return Object.keys(selected).every(function (index) {
        return variant.options[index] === selected[index];
      });
    });
  }

  function updateUI(variant) {
    if (!variant) return;
    var priceEl = form.closest('.al-product-info-list') ? form.closest('.al-product-info-list').querySelector('[data-product-price]') : document.querySelector('[data-product-price]');
    var compareEl = document.querySelector('[data-product-compare-price]');
    var badgeEl = document.querySelector('[data-product-badge]');
    var idInput = form.querySelector('[data-product-variant-id]');
    var addBtn = form.querySelector('[data-product-add-to-cart]');

    if (idInput) idInput.value = variant.id;
    if (priceEl) priceEl.textContent = formatMoney(variant.price);

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      if (compareEl) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.style.display = '';
      }
      if (badgeEl) {
        var pct = Math.round((1 - variant.price / variant.compare_at_price) * 100);
        badgeEl.textContent = 'Save ' + pct + '%';
        badgeEl.style.display = '';
      }
    } else {
      if (compareEl) compareEl.style.display = 'none';
      if (badgeEl) badgeEl.style.display = 'none';
    }

    if (addBtn) {
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available
        ? (window.themeStrings ? window.themeStrings.addToCart : 'Add to cart')
        : (window.themeStrings ? window.themeStrings.soldOut : 'Sold out');
    }

    if (variant.featured_media) {
      var slide = document.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
      var swiperEl = document.querySelector('[data-product-gallery]');
      if (slide && swiperEl && swiperEl.swiper) {
        var slideWrap = slide.closest('.swiper-slide');
        var index = Array.prototype.indexOf.call(swiperEl.querySelectorAll('.swiper-slide'), slideWrap);
        if (index > -1) swiperEl.swiper.slideTo(index);
      }
    }

    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  }

  form.addEventListener('click', function (e) {
    var btn = e.target.closest('.size_btn');
    if (!btn) return;
    var index = btn.getAttribute('data-option-index');
    var value = btn.getAttribute('data-option-value');
    selected[index] = value;

    var picker = btn.closest('.quick-variant-picker');
    picker.querySelectorAll('.size_btn').forEach(function (b) { b.classList.remove('active'); });
    btn.classList.add('active');
    picker.querySelector('.variant__value').textContent = value;

    updateUI(findVariant());
  });

  // Add to Cart / quantity stepper / View Cart: the stepper stays hidden
  // until this variant is actually in the cart. Adding shows it (plus a View
  // Cart link, replacing Add to Cart) in place, without leaving the product
  // page; from then on +/- adjust the real cart quantity via /cart/change.js,
  // and dropping to 0 swaps back to the Add to Cart state.
  var qtyWrap = form.querySelector('.js-pdp-qty');
  var qtyInput = form.querySelector('[data-product-qty]');
  var addBtn = form.querySelector('.js-pdp-add');
  var viewCartBtn = form.querySelector('.js-pdp-view-cart');

  function showInCartState(lineKey, quantity) {
    if (qtyWrap) {
      qtyWrap.classList.remove('d-none');
      qtyWrap.setAttribute('data-line-item-key', lineKey);
    }
    if (qtyInput) qtyInput.value = quantity;
    if (addBtn) addBtn.classList.add('d-none');
    if (viewCartBtn) viewCartBtn.classList.remove('d-none');
  }

  function showAddState() {
    if (qtyWrap) {
      qtyWrap.classList.add('d-none');
      qtyWrap.setAttribute('data-line-item-key', '');
    }
    if (qtyInput) qtyInput.value = 1;
    if (addBtn) addBtn.classList.remove('d-none');
    if (viewCartBtn) viewCartBtn.classList.add('d-none');
  }

  function changeCartQuantity(quantity) {
    var lineKey = qtyWrap.getAttribute('data-line-item-key');
    var routes = window.themeCart && window.themeCart.routes;
    if (!lineKey || !routes) return;
    qtyWrap.classList.add('is-loading');
    fetch(routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        window.themeCart.updateCartCountBadges(cart.item_count);
        if (quantity <= 0) {
          showAddState();
        } else if (qtyInput) {
          qtyInput.value = quantity;
        }
      })
      .catch(function () {})
      .finally(function () {
        qtyWrap.classList.remove('is-loading');
      });
  }

  if (qtyWrap && qtyInput) {
    form.addEventListener('click', function (e) {
      var isInCart = !!qtyWrap.getAttribute('data-line-item-key');
      if (e.target.closest('.btn-decrease')) {
        e.preventDefault();
        var next = Math.max(0, (parseInt(qtyInput.value, 10) || 1) - 1);
        if (isInCart) {
          changeCartQuantity(next);
        } else {
          qtyInput.value = Math.max(1, next);
        }
      } else if (e.target.closest('.btn-increase')) {
        e.preventDefault();
        var incremented = (parseInt(qtyInput.value, 10) || 1) + 1;
        if (isInCart) {
          changeCartQuantity(incremented);
        } else {
          qtyInput.value = incremented;
        }
      }
    });
  }

  form.addEventListener('submit', function (e) {
    if (!window.themeCart) return; // fall back to native form submit
    e.preventDefault();
    var variantId = form.querySelector('[data-product-variant-id]').value;
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    window.themeCart.addToCart(variantId, qty, addBtn, {
      onSuccess: function (data) {
        showInCartState(data.key, data.quantity || qty);
      }
    });
  });

  function initGallery() {
    var el = document.querySelector('[data-product-gallery]');
    if (!el || !window.Swiper) return;
    el.swiper = new window.Swiper(el, {
      navigation: { nextEl: '.single-slide-next', prevEl: '.single-slide-prev' },
      pagination: { el: '.al-sw-pagination', clickable: true }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initGallery();
  });
})();
